import { useState } from 'react';
import { Sheet, Field, Input, Textarea, Select, AssigneeChips, PrimaryBtn, GhostBtn } from './UI';
import { TEAM, STATUSES, today } from '../utils/constants';

const blank = () => ({
  title: '', assignees: [], status: 'Action Required',
  notes: '', type: 'tracker', subtype: 'tracker-incident',
  dateAdded: today(), dateResolved: null,
});

export function TrackerForm({ initial, currentUser, onSave, onClose }) {
  const [form, setForm] = useState(() => initial
    ? { ...initial }
    : { ...blank(), assignees: currentUser ? [currentUser] : [] }
  );
  const [saving, setSaving] = useState(false);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSave = async () => {
    if (!form.title.trim()) { alert('Tracker name is required.'); return; }
    setSaving(true);
    const resolved = form.status === 'Complete' && !form.dateResolved ? today() : form.dateResolved;
    await onSave({ ...form, type: 'tracker', dateResolved: resolved });
    setSaving(false);
  };

  const trackerStatuses = STATUSES.filter(s => s !== 'Pending Response');

  return (
    <Sheet
      title={initial ? 'Edit Tracker' : 'New Tracker'}
      onClose={onClose}
      footer={
        <>
          <GhostBtn onClick={onClose}>Cancel</GhostBtn>
          <PrimaryBtn onClick={handleSave} disabled={saving}>
            {saving ? 'Saving...' : 'Save Tracker'}
          </PrimaryBtn>
        </>
      }
    >
      <Field label="Tracker Name *">
        <Input
          value={form.title}
          onChange={e => set('title', e.target.value)}
          placeholder="e.g. Unity Mac Stability, Dreamcatcher Fiber Issues..."
          autoFocus
        />
      </Field>

      <Field label="Description">
        <Textarea
          rows={3}
          value={form.notes}
          onChange={e => set('notes', e.target.value)}
          placeholder="What system or service is this tracking? What kind of incidents belong here?"
        />
      </Field>

      <Field label="Tracker Type">
        <Select value={form.subtype || 'tracker-incident'} onChange={e => set('subtype', e.target.value)}>
          <option value="tracker-incident">Incident Tracker</option>
          <option value="tracker-task">Task Tracker</option>
        </Select>
      </Field>

      <Field label="Assigned To">
        <AssigneeChips team={TEAM} selected={form.assignees} onChange={v => set('assignees', v)} />
      </Field>

      <Field label="Status">
        <Select value={form.status} onChange={e => set('status', e.target.value)}>
          {trackerStatuses.map(s => <option key={s}>{s}</option>)}
        </Select>
      </Field>

      <Field label="Date Opened">
        <Input type="date" value={form.dateAdded} onChange={e => set('dateAdded', e.target.value)} />
      </Field>

      {form.status === 'Complete' && (
        <Field label="Date Resolved">
          <Input
            type="date"
            value={form.dateResolved || today()}
            onChange={e => set('dateResolved', e.target.value)}
          />
        </Field>
      )}
    </Sheet>
  );
}
